<div
  class="overflow-auto min-h-[1px] bg-[var(--background-card)]"
  [ngClass]="{ 'lg:max-h-[60vh] xl:max-h-[70vh]': stickyTop }"
>
  <ng-container *ngTemplateOutlet="selectionActionTemplate; context: { $implicit: selectedEl }"></ng-container>

  <table
    (matSortChange)="sortEvent($event)"
    *ngIf="showSort"
    [dataSource]="dataSource"
    [matSortActive]="matSortActiveColumn"
    [matSortDirection]="sortOrder"
    class="w-full shadow-none"
    mat-table
    matSort
    matSortDisableClear
    multiTemplateDataRows
  >
    <base-data-table-column
      (onArchiveItem)="archiveItem($event)"
      (onClickRow)="rowClick($event)"
      (onDeleteItem)="deleteItem($event)"
      (onSelectItem)="selectItem($event)"
      (onSuspendItem)="suspendItem($event)"
      (onSelectRow)="selectedRow($event)"
      (onUpdateItem)="updateItem($event)"
      (onDownloadItem)="downloadItem($event)"
      (onDuplicateItem)="duplicateItem($event)"
      (onFavoriteItem)="favoriteItem($event)"
      (onChangeReadStatus)="changeReadStatus($event)"
      (onValueChange)="valueChange($event)"
      (onHoverItem)="hoverItem($event)"
      *ngFor="let feiColumn of feisColumns"
      [actionsTemplate]="actionsTemplate"
      [additionalDisplay]="feiColumn.additionalDisplay"
      [attentionRequieredTooltip]="attentionRequiredTooltip"
      [canArchive]="feiColumn.canArchive"
      [canSuspend]="feiColumn.canSuspend"
      [statusClassFunc]="feiColumn.statusClassFunc"
      [indicatorFunc]="feiColumn.indicatorFunc"
      [canDelete]="feiColumn.canDelete"
      [allowTextWrap]="allowTextWrap"
      [canSelectMultiple]="canSelectMultiple"
      [canSort]="feiColumn.canSort"
      [canUpdate]="feiColumn.canUpdate"
      [canUpdateDynamically]="feiColumn.canUpdateDynamically"
      [canDeleteDynamically]="feiColumn.canDeleteDynamically"
      [canDuplicate]="feiColumn.canDuplicate"
      [canDownload]="feiColumn.canDownload"
      [showAction]="feiColumn.showAction"
      [showActionDynamically]="feiColumn.showActionDynamically"
      [canFavorite]="feiColumn.canFavorite"
      [canChangeStatus]="feiColumn.canChangeStatus"
      [checkboxTooltip]="feiColumn.checkboxTooltip"
      [clearSelectedRow]="clearSelectedEl"
      [clickEl]="feiColumn.click"
      [column]="feiColumn.column"
      [customColHeader]="feiColumn.customColHeader"
      [customColumnHeaderTemplate]="customColumnHeaderTemplate"
      [customColumnTemplate]="customColumnTemplate"
      [customDisplay]="feiColumn.customDisplay"
      [customExtraHtml]="feiColumn.customExtraHtml"
      [dataSource]="dataSource"
      [isOrderBasket]="isOrderBasket"
      [isPredik]="feiColumn.isPredik"
      [label]="feiColumn.label"
      [maxDecimal]="feiColumn.maxDecimal"
      [previousDisplay]="feiColumn.previousDisplay"
      [propertyDisplay]="feiColumn.propertyDisplay"
      [routerLinkDetailRow]="routerLinkDetailRow"
      [canSeeDetails]="!rowDetailBlocked"
      [selectAllDisabled]="selectAllDisabled"
      [selectedRows]="selectedRows"
      [status]="feiColumn.status"
      [titleCase]="feiColumn.titleCase"
      [type]="feiColumn.type"
      [upperCase]="feiColumn.upperCase"
      [value]="feiColumn.value"
      [width]="feiColumn.width"
      [minWidth]="feiColumn.minWidth"
      [wrap]="feiColumn.wrap"
      [canSelectCheckBoxRows]="canSelectCheckBoxRows"
      [actionText]="actionText"
      [isProductPrestation]="isProductPrestation"
    ></base-data-table-column>

    <ng-container *ngIf="accordeonRef" matColumnDef="expandedDetail">
      <td *matCellDef="let element" [attr.colspan]="displayedColumns.length" mat-cell>
        <div
          [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
          class="example-element-detail w-full flex-auto"
        >
          <ng-container
            *ngTemplateOutlet="accordeonRef; context: { value: element }"
            class="w-full flex-auto"
          ></ng-container>
        </div>
      </td>
    </ng-container>
    <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>

    <ng-container *matRowDef="let element; when: isSpecialRow" class="w-full">
      <td [attr.colspan]="displayedColumns.length">
        <ng-container *ngTemplateOutlet="subheaderTemplate; context: { $implicit: element }"></ng-container>
      </td>
    </ng-container>

    <ng-container *matRowDef="let element; columns: displayedColumns; let i = index; when: isNormalRow" class="w-full">
      <tr
        (click)="toggleRow(element)"
        class="hover:bg-hover trans-ease-out cursor-pointer text-secondary font-medium custom-tr"
        [ngStyle]="generateRowStyle(element)"
        mat-row
      ></tr>
    </ng-container>

    <ng-container *ngIf="accordeonRef">
      <tr *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" mat-row></tr>
    </ng-container>

    <ng-container>
      <tr *ngIf="!isLoading">
        <td *matNoDataRow [attr.colspan]="displayedColumns.length" class="text-center p-12 text-hint">
          Aucun résultat trouvé pour cette recherche
        </td>
      </tr>
    </ng-container>
  </table>
  <table
    *ngIf="!showSort"
    [dataSource]="dataSource"
    class="w-full"
    [ngClass]="{ 'wrap-text': allowTextWrap }"
    mat-table
    multiTemplateDataRows
  >
    <!--            &lt;!&ndash; Checkbox Column &ndash;&gt;-->
    <!--            <ng-container matColumnDef="select">-->
    <!--                <th mat-header-cell *matHeaderCellDef>-->
    <!--                    <mat-checkbox (change)="$event ? toggleAllRows() : null"-->
    <!--                                  [checked]="selection.hasValue() && isAllSelected()"-->
    <!--                                  [indeterminate]="selection.hasValue() && !isAllSelected()"-->
    <!--                                  [aria-label]="checkboxLabel()">-->
    <!--                    </mat-checkbox>-->
    <!--                </th>-->
    <!--                <td mat-cell *matCellDef="let row">-->
    <!--                    <mat-checkbox (click)="$event.stopPropagation()"-->
    <!--                                  (change)="$event ? selection.toggle(row) : null"-->
    <!--                                  [checked]="selection.isSelected(row)"-->
    <!--                                  [aria-label]="checkboxLabel(row)">-->
    <!--                    </mat-checkbox>-->
    <!--                </td>-->
    <!--            </ng-container>-->

    <base-data-table-column
      (onArchiveItem)="archiveItem($event)"
      (onClickRow)="rowClick($event)"
      (onDeleteItem)="deleteItem($event)"
      (onDuplicateItem)="duplicateItem($event)"
      (onSelectItem)="selectItem($event)"
      (onSuspendItem)="suspendItem($event)"
      (onSelectRow)="selectedRow($event)"
      (onUpdateItem)="updateItem($event)"
      (onDownloadItem)="downloadItem($event)"
      *ngFor="let feiColumn of feisColumns"
      [actionsTemplate]="actionsTemplate"
      [additionalDisplay]="feiColumn.additionalDisplay"
      [canArchive]="feiColumn.canArchive"
      [canSuspend]="feiColumn.canSuspend"
      [canDelete]="feiColumn.canDelete"
      [canSelectMultiple]="canSelectMultiple"
      [canUpdate]="feiColumn.canUpdate"
      [allowTextWrap]="allowTextWrap"
      [canUpdateDynamically]="feiColumn.canUpdateDynamically"
      [canDeleteDynamically]="feiColumn.canDeleteDynamically"
      [canDuplicate]="feiColumn.canDuplicate"
      [canDownload]="feiColumn.canDownload"
      [showAction]="feiColumn.showAction"
      [showActionDynamically]="feiColumn.showActionDynamically"
      [column]="feiColumn.column"
      [statusClassFunc]="feiColumn.statusClassFunc"
      [indicatorFunc]="feiColumn.indicatorFunc"
      [customColumnTemplate]="customColumnTemplate"
      [customDisplay]="feiColumn.customDisplay"
      [dataSource]="dataSource"
      [label]="feiColumn.label"
      [maxDecimal]="feiColumn.maxDecimal"
      [previousDisplay]="feiColumn.previousDisplay"
      [propertyDisplay]="feiColumn.propertyDisplay"
      [routerLinkDetailRow]="routerLinkDetailRow"
      [canSeeDetails]="!rowDetailBlocked"
      [selectAllDisabled]="selectAllDisabled"
      [selectedRows]="selectedRows"
      [showSort]="showSort"
      [titleCase]="feiColumn.titleCase"
      [type]="feiColumn.type"
      [upperCase]="feiColumn.upperCase"
      [width]="feiColumn.width"
      [minWidth]="feiColumn.minWidth"
      [wrap]="feiColumn.wrap"
    ></base-data-table-column>

    <!--            <ng-container matColumnDef="expandedDetail" *ngIf='accordeonRef'>-->
    <!--                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">-->
    <!--                    <div class="example-element-detail max-w-full max-w-max w-full"-->
    <!--                         [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">-->
    <!--                            <ng-container *ngTemplateOutlet="accordeonRef"></ng-container>-->
    <!--                    </div>-->
    <!--                </td>-->
    <!--            </ng-container>-->

    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
    <tr
      (click)="toggleRow(element)"
      *matRowDef="let element; columns: displayedColumns; let i = index"
      class="hover:bg-hover trans-ease-out cursor-pointer w-full max-w-full text-secondary font-medium custom-tr"
      [ngStyle]="generateRowStyle(element)"
      mat-row
    ></tr>
    <!--            <ng-container *ngIf='accordeonRef'>-->
    <!--                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>-->
    <!--            </ng-container>-->
  </table>
  <table class="w-full flex justify-center p-1">
    <!--            <tr *ngIf="!dataSource.data.length">-->
    <!--                <td class="center" [attr.colspan]="displayedColumns.length">-->
    <!--                    Aucune donnée trouvée !-->
    <!--                </td>-->
    <!--            </tr>-->
  </table>

  <mat-paginator
    #paginator
    (page)="pageEvent($event)"
    *ngIf="showPaginator"
    [length]="count"
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex ? pageIndex - 1 : 0"
    [ngClass]="{ 'sticky bottom-0 z-10 bg-white': stickyTop }"
    showFirstLastButtons
  ></mat-paginator>
</div>
